export default __webpack_public_path__ + "static/voice-of-children-9eba32feea7ee66dce9a8ca3eeb9ada2.svg";